module.exports = __webpack_public_path__ + "static/media/yaronPhoto.813581da.jpeg";